import ThemeProvider from '@shazambanking/sdk/components/ThemeProvider';
import { showErrorNotification } from '@shazambanking/sdk/services/notifications';
import { ThemeState } from '@shazambanking/sdk/types/state';
import { get } from 'lodash';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import setL10N from './core/store/sagas/util/setL10n';
import { fetchNewAccountStartupData, getTheme } from './new-account/api/newAccount';
import NewAccountConfirmation from './new-account/components/NewAccountConfirmation';
import NewAccountUi from './new-account/components/NewAccountUi';
import { NewAccountStartupResource } from './new-account/types';

export default function App() {
  const [theme, setTheme] = useState<ThemeState>();
  const [startupData, setStartupData] = useState<NewAccountStartupResource>();

  useEffect(() => {
    const getThemeData = async () => {
      try {
        const response = await getTheme();
        setTheme(response);
      } catch (error) {
        showErrorNotification(get(
          error,
          'response.data.message',
          'Server error. Please try again.'
        ));
      }
    }
    getThemeData();
  }, []);
  
  useEffect(() => {
    const getStartupData = async () => {
      try {
        const response = await fetchNewAccountStartupData();
        setL10N(response.localization);
        setStartupData(response);
      } catch (error) {
        showErrorNotification(get(
          error,
          'response.data.message',
          'Server error. Please try again.'
        ));
      }
    }
    getStartupData();
  }, []);

  if (startupData === undefined) {
    return <></>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Router basename="/new-account">
        <Switch>
          <Route path="/" exact={true}>
            <Redirect to={"/open"} />
          </Route>
          <Route path={"/open"} exact={true} render={( props ) => <NewAccountUi startupData={startupData} {...props} />} />
          <Route path={"/confirmation"} exact={true} component={NewAccountConfirmation} />
        </Switch>
      </Router>
    </ThemeProvider>
  );
};
